/* Nalzea Live: anonymous real-time signals for the Nalzea Live dashboard (no cookies, nothing stored on the device).
   Sends: page view, heartbeat, add to cart, quantity change, removal from the cart, departure to the checkout, page exit,
   plus shop health (JavaScript errors of the theme, cart requests refused by Shopify, carts the Amboras bridge could not
   carry over). The cart is read from Shopify's /cart.js after each change; amounts are sent in euros.
   Page context (template, language, product) comes from snippets/nz-live.liquid. */
(() => {
  const EP = 'https://nalzea-live.bibitrikiewen.workers.dev/e';
  const ua = navigator.userAgent || '';
  if (navigator.webdriver || /bot|crawl|spider|lighthouse|headless|preview/i.test(ua)) return;
  if ((window.Shopify && window.Shopify.designMode) || /preview_theme_id|oseid/.test(location.search)) return; // theme editor, previews

  const run = () => {
    const id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    let cfg = {};
    try { cfg = JSON.parse((document.getElementById('nz-live') || {}).textContent || '{}'); } catch (e) {}
    const lang = String(cfg.l || (window.Shopify && window.Shopify.locale) || 'fr').slice(0, 2);
    // Shopify amounts are cents in the shopper's currency (= euros × rate).
    const rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    const eur = cents => Math.round(Number(cents || 0) / rate) / 100;
    const mobile = matchMedia('(pointer:coarse)').matches ? 1 : 0;
    const small = src => {
      let s = String(src || '');
      if (!s) return '';
      if (s.startsWith('//')) s = 'https:' + s;
      try { const u = new URL(s, location.href); u.searchParams.set('width', '200'); return u.href; } catch (e) { return s; }
    };
    const pr = cfg.pr && cfg.pr.h ? { h: cfg.pr.h, t: cfg.pr.t || '', img: small(cfg.pr.img), price: eur(cfg.pr.price), b: cfg.pr.b || '' } : null;
    let ref = null, internal = false;
    try { if (document.referrer) { ref = new URL(document.referrer); internal = ref.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, ''); } } catch (e) {}
    let qs = null;
    try { qs = new URLSearchParams(location.search); } catch (e) {}
    const q = k => ((qs && qs.get(k)) || '').trim();

    // The cart as last read from /cart.js (line key -> line), and its item count.
    let cart = null;
    const bubble = () => {
      const el = document.querySelector('.cart-bubble__text-count');
      const n = el ? Number((el.textContent || '').trim()) : NaN;
      return isFinite(n) ? n : null;
    };
    const count = () => (cart ? cart.count : bubble() || 0);

    const send = (t, extra, beacon) => {
      const body = JSON.stringify(Object.assign({ t, i: id, p: location.pathname, ti: document.title, tp: cfg.tp || '', l: lang, m: mobile, cc: count() }, extra || {}));
      try {
        if (beacon && navigator.sendBeacon && navigator.sendBeacon(EP, body)) return;
        of(EP, { method: 'POST', body, keepalive: true, mode: 'cors', credentials: 'omit', headers: { 'content-type': 'text/plain' } }).catch(() => {});
      } catch (e) {}
    };
    const of = window.fetch.bind(window);

    send('v', { pr, r: ref && !internal ? ref.hostname : '', rn: internal ? 1 : 0, us: q('utm_source').toLowerCase().slice(0, 40), uc: q('utm_campaign').slice(0, 60), tt: q('ttclid') ? 1 : 0 });
    let hb = null;
    const beat = () => { clearInterval(hb); hb = setInterval(() => send('h', { pr }), 20000); };
    beat();
    // Page in front again (phone unlocked, tab reopened, back from the checkout): show the visitor again at once.
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') { send('h', { pr, back: 1 }); beat(); } });

    // Leaving to another page of the shop, or to the checkout, is not an exit.
    let nav = false;
    document.addEventListener('click', e => {
      const a = e.target && e.target.closest && e.target.closest('a[href]');
      if (a && a.hostname && a.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '') && !a.target && !e.metaKey && !e.ctrlKey && !e.shiftKey) nav = true;
    }, true);
    document.addEventListener('submit', () => { nav = true; }, true);

    // ---------- shop health: JavaScript errors of the theme's own files (a few per page, no duplicates) ----------
    let nErr = 0, leaving = false;
    const seenErr = new Set();
    const bare = u => String(u || '').split('#')[0].split('?')[0];
    const theme = u => /\/t\/\d+\/(compiled_)?assets\//i.test(String(u || ''));
    const ours = u => theme(u) || (!!u && bare(u) === bare(location.href));
    const errOut = (m, src, ln) => {
      m = String(m || '').replace(/\s+/g, ' ').trim().slice(0, 160);
      src = String(src || '');
      if (leaving || document.hidden || !m || nErr >= 6 || !ours(src)) return;
      if (/^Script error\.?$|ResizeObserver loop|Non-Error promise rejection|Load failed|Failed to fetch|NetworkError|AbortError|operation was aborted|cancel/i.test(m)) return;
      const k = m + '|' + src + '|' + ln;
      if (seenErr.has(k)) return;
      seenErr.add(k); nErr++;
      send('err', { m, s: src.split('?')[0].split('/').pop().slice(0, 80), ln: Number(ln) || 0, tv: 3 });
    };
    // A theme file that did not arrive is fetched again; only a second failure is a real problem.
    const retried = new Set();
    const reload = (tag, u) => {
      if (leaving || retried.has(bare(u))) return;
      retried.add(bare(u));
      const n = document.createElement(tag);
      const again = u + (u.indexOf('?') < 0 ? '?' : '&') + 'r=' + Date.now().toString(36);
      if (tag === 'link') { n.rel = 'stylesheet'; n.href = again; } else { n.src = again; n.async = false; }
      n.addEventListener('error', () => errOut('Fichier du thème non chargé : ' + bare(u).split('/').pop(), u, 0));
      (document.head || document.documentElement).appendChild(n);
    };
    addEventListener('error', e => {
      const tg = e.target;
      if (tg && tg !== window && (tg.tagName === 'SCRIPT' || tg.tagName === 'LINK')) {
        const u = tg.src || tg.href || '';
        if (theme(u) && !/[?&]r=/.test(u) && tg.type !== 'module' && (tg.tagName === 'SCRIPT' || /stylesheet/i.test(tg.rel || ''))) reload(tg.tagName === 'LINK' ? 'link' : 'script', u);
        return;
      }
      if (e.message) errOut(e.message, e.filename, e.lineno);
    }, true);
    addEventListener('unhandledrejection', e => {
      const r = e.reason;
      const m = r && (r.message || (typeof r === 'string' ? r : ''));
      const src = (r && r.stack && (String(r.stack).match(/https?:\/\/[^\s)]+/) || [''])[0]) || '';
      if (m && src) errOut(m, src, 0);
    });

    // ---------- cart: read /cart.js after each change and compare with the cart before ----------
    const lineOf = x => ({
      q: Number(x.quantity) || 0, p: eur(x.final_price != null ? x.final_price : x.price), h: x.handle || '', t: String(x.product_title || x.title || '').slice(0, 90),
      img: small(x.featured_image && x.featured_image.url ? x.featured_image.url : x.image), b: x.vendor || '', s: x.sku || '',
    });
    // Lines are followed by variant: Shopify gives a line a new key when its quantity or discount changes.
    const snap = c => {
      const lines = new Map();
      (c.items || []).forEach(x => {
        const k = String(x.variant_id || x.id || x.key), l = lineOf(x), o = lines.get(k);
        if (o) { o.p = (o.p * o.q + l.p * l.q) / Math.max(1, o.q + l.q); o.q += l.q; } else lines.set(k, l);
      });
      return {
        count: Number(c.item_count) || 0, total: eur(c.total_price), lines,
        codes: (Array.isArray(c.discount_codes) ? c.discount_codes : []).filter(d => d && d.applicable !== false).map(d => String(d.code || '').toUpperCase()).filter(Boolean).slice(0, 4),
      };
    };
    const readCart = () => of((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { accept: 'application/json' } })
      .then(r => (r.ok ? r.json() : null)).then(c => (c && Array.isArray(c.items) ? snap(c) : null)).catch(() => null);
    // A change made by an add-to-cart request counts as "added"; other changes as quantity changes / removals.
    const report = (before, after, how) => {
      const cc = after.count;
      after.lines.forEach((x, k) => {
        const b = before && before.lines.get(k), q0 = b ? b.q : 0;
        if (x.q === q0) return;
        const info = { ph: x.h, pt: x.t, pimg: x.img, b: x.b, cc };
        if (x.q > q0 && (how === 'add' || !b)) send('c', Object.assign(info, { q: x.q - q0, a: Math.round(x.p * (x.q - q0) * 100) / 100, s: x.s }));
        else send('cu', Object.assign(info, { q0, q1: x.q, a: Math.round(x.p * (x.q - q0) * 100) / 100 }));
      });
      if (before) before.lines.forEach((b, k) => { if (!after.lines.has(k)) send('cr', { ph: b.h, pt: b.t, pimg: b.img, b: b.b, q0: b.q, q1: 0, a: Math.round(b.p * b.q * 100) / 100, cc }); });
    };
    let chain = Promise.resolve(), lastSync = 0;
    const sync = how => {
      lastSync = Date.now();
      chain = chain.then(() => readCart().then(after => {
        if (!after) return;
        const before = cart;
        cart = after;
        if (before || how === 'add') report(before, after, how);
      }));
      return chain;
    };
    // Starting point: the cart as the page opens (only read when it is not empty).
    const b0 = bubble();
    if (b0 === 0) cart = { count: 0, total: 0, codes: [], lines: new Map() };
    else readCart().then(c => { if (c && !cart) cart = c; });
    // Cart changed by something the requests below did not show (an app, Shopify's own actions): the bubble moves.
    const bub = document.querySelector('.cart-bubble__text-count');
    if (bub && window.MutationObserver) {
      let tm = 0;
      new MutationObserver(() => { clearTimeout(tm); tm = setTimeout(() => { if (Date.now() - lastSync > 1500 && bubble() !== count()) sync('auto'); }, 500); })
        .observe(bub, { childList: true, characterData: true, subtree: true });
    }

    // ---------- the theme's requests: cart changes (Shopify) and the hand-over to the Amboras checkout ----------
    const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    const GQL_RE = /\/api\/(unstable|\d{4}-\d{2})\/graphql(\.json)?(\?|$)/;
    window.fetch = function (input, init) {
      let kind = '', how = '';
      try {
        const u = typeof input === 'string' ? input : (input && input.url) || String(input || '');
        const m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (m === 'POST') {
          const cm = u.match(CART_RE);
          if (cm && new URL(u, location.href).origin === location.origin) { kind = 'cart'; how = cm[1] === 'add' ? 'add' : 'change'; }
          else if (GQL_RE.test(u) && /cartLines(Add|Update|Remove)/.test(String((init && init.body) || ''))) { kind = 'cart'; how = /cartLinesAdd/.test(String(init.body)) ? 'add' : 'change'; }
          else if (/amboras\.com\/store\/carts/.test(u)) kind = 'checkout';
        }
      } catch (e) {}
      const res = of.apply(window, arguments);
      if (kind) {
        res.then(r => {
          if (!r || !r.ok) { send('fail', { api: kind, st: r ? r.status : 0 }); return; }
          if (kind === 'cart') sync(how);
        }, err => {
          if (!/abort/i.test(String((err && err.name) || '') + String((err && err.message) || ''))) send('fail', { api: kind, st: 0 });
        });
      }
      return res;
    };

    // Departure to the checkout: the cart's lines, total (discount codes included) and codes travel with it.
    // The cart is read again first (a welcome code may have been applied since); the bridge takes longer than that
    // to open the checkout, and the page leaving sends what is known.
    let lastK = 0, pendingK = null;
    const toCheckout = () => {
      if (Date.now() - lastK < 10000) return;
      lastK = Date.now(); nav = true;
      let done = false;
      const fin = c => {
        if (done) return;
        done = true; pendingK = null;
        if (c) cart = c;
        const k = cart || { total: 0, codes: [], lines: new Map() };
        const it = [...k.lines.values()].slice(0, 12).map(x => ({ s: x.s, h: x.h, t: x.t.slice(0, 60), q: x.q, p: x.p }));
        send('k', { a: k.total, it, cd: k.codes }, true);
      };
      pendingK = () => fin(null);
      readCart().then(fin);
      setTimeout(() => fin(null), 1500);
    };
    addEventListener('click', e => {
      const el = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
      if (el) toCheckout();
    }, true);
    addEventListener('submit', e => {
      const s = e.submitter;
      if ((s && s.name === 'checkout') || /\/checkouts?(\/|$|\?)/.test(String((e.target && e.target.action) || ''))) toCheckout();
    }, true);

    addEventListener('pagehide', () => { leaving = true; clearInterval(hb); if (pendingK) pendingK(); send('x', { ex: nav ? 0 : 1 }, true); });
    addEventListener('pageshow', e => { if (e.persisted) { leaving = false; nav = false; send('h', { pr, back: 1 }); beat(); } });
  };

  // Pages the browser prepares in advance (link hovered) only count once the visitor really opens them.
  if (document.prerendering) document.addEventListener('prerenderingchange', run, { once: true });
  else run();
})();
